import React from 'react';

const ReportingAI = () => {
    return <div />;
};

export default ReportingAI;
